<template>
  <div class="page-experts">
    <!-- banner开始 -->
    <div class="row">
      <div class="banner expert_banner pc">
        <div class="banner_mid" style="background: url(../../../static/images/banner_experts.png) top center no-repeat">
          <div class="banner_top">
            <div class="introduce">
              <p>客座教练</p>
              <p>超过600位一线教练进行传授,与优秀比肩在不知不觉中提升！</p>
            </div>
          </div>
        </div>
        <div class="banner_bottom">
          <div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <h1>众"智"成城</h1>
                <p>将您的知识、技能和经验作为资源加入到更加开放自由的价值置换体系中，将您的卓越研发经验放大。</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <h1>牛人聚集</h1>
                <p>与其他客座教练在切磋中扩大人脉，参加不定期组织的教练游学、企业互访。</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <h1>经济价值</h1>
                <p>真正有价值的知识不应免费供应，加入客座教练直接将认知盈余兑换出知识的经济价值。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wap_banner_schedule mob">
        <h1>专家客座教练</h1>
        <p>超过600位一线教练进行传授,与优秀比肩在不知不觉中提升！</p>
      </div>
    </div>
    <!-- 国内外技术专家pc端开始 -->
    <div class="person row pc experts">
      <div class="all">
        <h1>教练成员</h1>
        <!-- <div class="text-center">
          <a href="http://vip.msup.com.cn/index.php/site/coach" target="_blank" class="more">
            申请教练
          </a>
        </div> -->
        <ul>
          <li v-for="(item,index) in lecturers.slice(0,len)" :key="'lecturer'+ index">
            <a @click.prevent="toNext(item.id)">
              <div class="img"><div>
                <img :src="item.thumbs?getThumbs(item.thumbs):'../../static/images/def.jpg'"/>
              </div></div>
              <div class="text">
                <span>{{ (item.penName != "" && item.penName != null ) ? item.penName : item.name }}</span>
                <p class="person_p2">{{item.company}}</p>
                <p>{{item.position}}</p>
              </div>
            </a>
          </li>
        </ul>
        <div class="text-center">
          <a v-if="lecturers.length>len" @click="len=lecturers.length" class="more">更多教练</a>
        </div>
      </div>
    </div>
    <!-- 国内外技术专家手机端开始 -->
    <div class="wap_person row mob">
      <h1>教练成员</h1>
      <!-- <div class="text-center cha">
        <a href="http://vip.msup.com.cn/index.php/site/coach" target="_blank" class="more">
          申请教练
        </a>
      </div> -->
      <ul class="row">
        <li v-for="(item,index) in lecturers" :key="'wap_lecturer'+index">
          <a @click.prevent="toNext(item.id)">
            <div class="img"><div>
              <img :src="item.thumbs?getThumbs(item.thumbs):'../../static/images/def.jpg'"/>
            </div></div>
            <div class="text">
              <span>{{item.name}}</span> <br>
              <span class="sp2">{{item.company}}<br>{{item.position}}</span>
            </div>
          </a>
        </li>
      </ul>
      <div class="text-center cha" v-if="lecturers && lecturers.length>len">
        <!-- <a href="/coach" class="more">更多教练</a> -->
        <a @click="len=lecturers.length" class="more">更多教练</a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import $ from 'jquery'

export default {
  name: 'Experts',
  data () {
    return {
      lecturers: [],
      len: 25
    }
  },
  created () {
    this.getLecturers()
  },
  methods: {
    getThumbs: function (img) {
      return img.split('?')[0] + '?imageView2/1/w/200/h/200/q/100'
      // return img.split('?')[0]+'?imageMogr2/auto-orient/thumbnail/200x/gravity/North/crop/200x200/blur/1x0/quality/100';
    },
    toNext: function (e) {
      this.$router.push({path: '/teacher', name: 'Teacher', query: {sid: this.$route.query.sid, id: e}})
    },
    getLecturers: function () {
      var area_id = this.global.area_id
      if (this.$route.query.sid) {
        area_id = this.$route.query.sid
      }
      var url_lecturers = this.global.url.lecturers + area_id
      // console.log(url_lecturers)
      this.$http
        .jsonp(url_lecturers)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data);
          this.lecturers = []
          if (data.errno && data.errno.toString() === '0') {
            this.lecturers = data.data
            // console.log(this.lecturers);
          } else {
            // console.log("请求错误");
            let msg = data.errmsg ? data.errmsg : '请求错误'
            console.log(msg)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.page-experts {
  .person.pc ul {
    margin-top: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Experts.vue